import {SagaIterator} from "redux-saga";
import {spawn} from "redux-saga/effects";
import projectsSaga from "./projects/saga";
import usersSaga from "./users/saga";
import projectSaga from "./projects/project/saga";


export default function* routesSaga(): SagaIterator {
  yield spawn(projectsSaga);
  yield spawn(projectSaga);
  yield spawn(usersSaga);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/saga.ts